module.exports = __webpack_public_path__ + "files/73c70cbcecca28d475c3abe69c8ab969.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-1.png
// module id = 1483
// module chunks = 60